import { handleActions, combineActions } from "redux-actions";
import { AppState } from "../../../models";
import { NotificationAcionTypes } from "../../actions";

const notificationsState: AppState.AppNotifications = {
  list: [],
};

export const NotificationReducer = handleActions(
  {
    /* tên trong action phải giống khi sử dụng nhưng khác là dùng camelCase */
    [combineActions(NotificationAcionTypes.enqueueSnackbar, NotificationAcionTypes.removeSnackbar).toString()]: (
      state: AppState.AppNotifications,
      action
    ) => ({
      ...state,
      ...action.payload,
    }),
  },
  notificationsState
);
